import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import ChevronDownIcon from "@/assets/icons/tipo-chevron-down.svg?react";
import TrashIcon from "@/assets/icons/tipo-trash.svg?react";
import { Dropdown, FormField, Icon } from "@/ds";
import { ESCOPO_MACRO } from "../../../../../nova-obra.constants";
import styles from "./escopo-macro-novo.module.scss";

const { campos } = ESCOPO_MACRO;

/** Escopo macro novo, aberto com o formulário (Figma `escopo novo`); só a casca: sem valor, validação nem envio, tudo desabilitado. */
export function EscopoMacroNovoView() {
  return (
    <div className={styles.novo} data-testid="escopo-macro-novo">
      <div className={styles.cabecalho}>
        <Button
          type="button"
          rounded
          text
          size="small"
          severity="secondary"
          icon={<ChevronDownIcon aria-hidden />}
          aria-label={`${ESCOPO_MACRO.recolher} ${ESCOPO_MACRO.novoTitulo}`}
          disabled
        />
        <span className={styles.titulo}>{ESCOPO_MACRO.novoTitulo}</span>
        <Button
          type="button"
          rounded
          text
          size="small"
          severity="secondary"
          icon={<TrashIcon aria-hidden />}
          aria-label={`${ESCOPO_MACRO.remover} ${ESCOPO_MACRO.novoTitulo}`}
          disabled
        />
      </div>
      <div className={styles.formulario}>
        <FormField.Root className={styles.campo}>
          <FormField.Label>{campos.escopo.label}</FormField.Label>
          <FormField.Control>
            <InputText
              className="p-inputtext-sm"
              placeholder={campos.escopo.placeholder}
              disabled
            />
          </FormField.Control>
        </FormField.Root>
        <div className={styles.linhaCampos}>
          <FormField.Root className={`${styles.campo} ${styles.campoData}`}>
            <FormField.Label>{campos.inicio.label}</FormField.Label>
            <FormField.Control>
              <IconField iconPosition="left">
                <InputIcon className={styles.iconeData}>
                  <Icon name="calendar" size={14} />
                </InputIcon>
                <InputText
                  className="p-inputtext-sm"
                  placeholder={campos.inicio.placeholder}
                  disabled
                />
              </IconField>
            </FormField.Control>
          </FormField.Root>
          <FormField.Root className={`${styles.campo} ${styles.campoData}`}>
            <FormField.Label>{campos.fim.label}</FormField.Label>
            <FormField.Control>
              <IconField iconPosition="left">
                <InputIcon className={styles.iconeData}>
                  <Icon name="calendar" size={14} />
                </InputIcon>
                <InputText
                  className="p-inputtext-sm"
                  placeholder={campos.fim.placeholder}
                  disabled
                />
              </IconField>
            </FormField.Control>
          </FormField.Root>
          <FormField.Root className={`${styles.campo} ${styles.campoOrigem}`}>
            <FormField.Label>{campos.origem.label}</FormField.Label>
            <FormField.Control>
              <Dropdown size="sm" options={[]} placeholder={campos.origem.placeholder} disabled />
            </FormField.Control>
          </FormField.Root>
        </div>
        <FormField.Root className={styles.campo}>
          <FormField.Label>{campos.descricao.label}</FormField.Label>
          <FormField.Control>
            <InputText
              className="p-inputtext-sm"
              placeholder={campos.descricao.placeholder}
              disabled
            />
          </FormField.Control>
        </FormField.Root>
      </div>
    </div>
  );
}
